import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updatePreset } from '@api/kpi';

import { IUpdatePresetDTO } from '@interfaces/kpi/dto/kpiPresetsDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { PRESET_OPTIONS, UPDATE_PRESET } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdatePreset = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleUpdatePreset,
		isLoading: isLoadingUpdatePreset,
	} = useMutation<IUpdatePresetDTO>({
		mutationKey: [UPDATE_PRESET],
		allowedRoles: [EUserRoles.networkOperatorKpiUpdater, EUserRoles.networkOperatorKpiViewer],
		mutationFn: ({
			data,
			onSuccess,
		}: IUpdatePresetDTO) => updatePreset(data)
			.then((data) => {
				if (onSuccess) {
					onSuccess({
						aggregationType: data.aggregationType,
						from: data.from,
						granularity: data.granularity?.name,
						isAutomaticGranularity: data.isAutomaticGranularity,
						kpiIds: data.kpis?.map((kpi) => kpi.id) || [],
						presetId: data.id,
						sites: data.sites,
						to: data.to,
						vendor: data.vendor.name,
					});
				}
			}),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.editPreset,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([PRESET_OPTIONS]);
		},
	});

	return {
		handleUpdatePreset,
		isLoadingUpdatePreset,
	};
};
